import { enableProdMode, APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { forEach, map, compact, isUndefined } from 'lodash';
import 'whatwg-fetch'

if (environment.production) {
  enableProdMode();
}

let username = 'dannylane';
let password = 'dannylane2017';

function getThreeColPageChildrenNavItems(page: any) {
  return compact(map(page.cols, (item: any) => {
    return isUndefined(item.slug) ? null : {
      parent_id: page.id,
      slug: item.slug,
      title: item.title,
      parent_position: item.col * 100 + item.position
    }
  }));
}

function start() {
  platformBrowserDynamic().bootstrapModule(AppModule);
}

Promise.all([fetch(`${appConfig.apiUrl}/menu`), fetch(`${appConfig.apiUrl}/categories`)]).then((responses) => {
  return Promise.all([responses[0].json(), responses[1].json()]).then((data) => {
    window['categories'] = data[1].categories;
    let menu = data[0].menu.filter((page: any) => {
      page.children = page.children.filter((item: any) => {
        return item.is_disabled !== 1;
      });
      return page.is_disabled !== 1;
    });

    let pagesWithId = data[0].menu.filter((page: any) => {
      return page.page_id !== 0;
    });

    let reqsForParentPagesWithId = map(pagesWithId, (item: any) => {
      return fetch(`${appConfig.apiUrl}/pages/${item.page_id}`);
    });

    if (pagesWithId.length > 0) {
      Promise.all(reqsForParentPagesWithId).then((responses) => {
        return Promise.all(map(responses, (response) => { return response.json() })).then((dataArr) => {
          forEach(dataArr, (data, index) => {
            let page = data['pages'][0];
            if (page.page_type === 'column') {
              pagesWithId[index].page_type = 'column';
              pagesWithId[index].children = getThreeColPageChildrenNavItems(page);
            }
          });
          window['menu'] = menu;
          start();
        });
      });
    } else {
      window['menu'] = menu;
      start();
    }
  });
});


// WEBPACK FOOTER //
// ./src/main.ts